import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import useAttendanceUiEnabled from '../hooks/useAttendanceUiEnabled';

// Routes that exist only for practices with attendance capture enabled
// (PracticePreferences.attendance_capture_eligible). Fails closed like the flag.
export default function AttendanceUiGuard({ children }) {
    const enabled = useAttendanceUiEnabled();
    if (!enabled) return <Navigate to="/dashboard/app" replace />;
    return <>{children}</>;
}

AttendanceUiGuard.propTypes = {
    children: PropTypes.node,
};
